var mentions_default = {
  "mention": "VjxO1",
  "mentionViewer": "PMjXL",
  "cursorDefault": "B5I4f",
  "cursorPointer": "sB1sY"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
